export default __webpack_public_path__ + "static/media/estrella-blanca-01.188226aa.png";